export enum RouteName {
  List = 'product-catalog',
}
